module.exports = __webpack_public_path__ + "img/bronze-medal.84de3b39.png";